import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { sleep } from '@/utils/sleep'
import axios, { endpoints } from '@/lib/axios'
import { useBoolean } from '@/hooks/use-boolean'
import { useDeepEffect } from '@/hooks/use-deep-effect'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

import { Program } from './program.types'
import LiveStreamPlayer from './live-stream-player'
import { LiveCommentSection } from './live-comment-section'

type Props = {
  program: Program
}

const TEMP_STREAM_UID_KEY = 'rfc_temp_stream_uid_admin'

export default function ProgramPreviewCard({ program }: Props) {
  const [token, setToken] = useState<string | null>(null)
  const isLoading = useBoolean(false)
  const [publicUid, setPublicUid] = useState<string | undefined>(undefined)

  useDeepEffect(() => {
    ;(async () => {
      try {
        isLoading.onTrue()
        if (!program.id || !program.channelName || !program.streamKey) {
          return
        }

        // Get or generate UUID
        const storedUuid = localStorage.getItem(TEMP_STREAM_UID_KEY)
        let uuid = ''

        if (storedUuid) {
          uuid = storedUuid
        } else {
          const generateUUID = uuidv4().replace(/-/g, '')
          localStorage.setItem(TEMP_STREAM_UID_KEY, generateUUID)
          uuid = generateUUID
        }

        setPublicUid(uuid)

        // Use the new API endpoint with UUID
        const tokenRes = await axios.post(endpoints.programs.getToken, {
          uid: uuid,
          programId: program.id,
        })

        if (!tokenRes) {
          return
        }

        await sleep(800)

        setToken(tokenRes.data.token)
      } catch (error) {
        console.error(error)
      } finally {
        isLoading.onFalse()
      }
    })()

    return () => {
      localStorage.removeItem(TEMP_STREAM_UID_KEY)
    }
  }, [])

  const renderLiveContent = () => {
    if (program?.channelName && token && program?.id && publicUid) {
      return (
        <LiveStreamPlayer
          programId={program.id}
          channel={program.channelName}
          token={token}
          uid={publicUid}
        />
      )
    }

    return null
  }

  return (
    <Card>
      <CardHeader className="px-4 sm:px-6">
        <CardTitle className="text-base sm:text-lg font-semibold text-black flex justify-between items-center">
          <p>ถ่ายทอดสด</p>
        </CardTitle>
      </CardHeader>
      <CardContent className="gap-4 sm:gap-6 w-full">
        <div className="aspect-[16/9] bg-black flex items-center justify-center">
          {/* {isStreaming ? (
            renderLiveContent()
          ) : (
            <div className="text-center text-sm text-gray-500">
              ไม่มีการถ่ายทอดสด
            </div>
          )} */}
          {renderLiveContent()}
        </div>

        <LiveCommentSection programId={program.id} />
      </CardContent>
    </Card>
  )
}
